import { Badge as AdminBadge, type BadgeProps } from '@iws/admin-ui/badge'

import { cn } from '@/lib/utils'

/** The admin badge with the POS radius (4px). */
export const Badge = ({ className, ...props }: BadgeProps) => <AdminBadge className={cn('rounded-xs', className)} {...props} />
